import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Storage} from '@client/storage'
import {Tracking, TrackingEvent} from '@common/tracking'
import {IconButton, LinkButton} from '@components/common/base/buttons'
import {PageService} from '@extensions/page-service'
import {useTheme} from '../../../hooks/useTheme'

const storagePromoVisibilityKey = 'board-settings-extensions-promo-banner'

const TwContainer = tw.div`
  mt-8
  mr-8
`

const TwCard = tw.div`
  mt-8
  p-12
  rounded-12
  relative
  group
`

const TwCloseIcon = tw.div`
  absolute
  top-12
  right-12
  opacity-0
  group-hover:opacity-100
  transition-opacity
  duration-200
`

const TwCardTitle = tw.div`
  h2-semibold
  text-primary
  pb-7
`

const TwCardDescription = tw.div`
  text-sm-regular
  text-secondary
  pb-11
`

const TwCardLink = tw(LinkButton)`
  flex
  items-center
  justify-center
  rounded-6
  w-full
  h-28
  px-8
  py-6
  bg-background-primary
  text-action-default
  text-xs-regular 
`
interface ExtendedEntryHelperProps {
  theme: 'light' | 'dark'
  onClose: () => void
}

const PromoBlock = ({theme, onClose}: ExtendedEntryHelperProps) => {
  const isDark = theme === 'dark'
  return (
    <TwCard
      style={{
        // NOTE: custom shadow here is because it needs only for this promo,
        // so we do not use global variables or tailwind way to do that.
        boxShadow: isDark
          ? '0px 0px 3px 0px #375578 inset'
          : '0px 0px 3px 0px #E8F3FF inset',
        background: isDark
          ? 'linear-gradient(153.84deg, #252B35 46.23%, #375578 88.07%)'
          : 'linear-gradient(153.84deg, #FFFFFF 46.23%, #E8F3FF 88.07%)'
      }}
    >
      <TwCloseIcon onClick={onClose}>
        <IconButton icon="IconX" color="secondary" size="small" />
      </TwCloseIcon>
      <TwCardTitle>{Lang.msg.extensions.boardSettings.promoTitle}</TwCardTitle>
      <TwCardDescription>
        {Lang.msg.extensions.boardSettings.promoDescrption}
      </TwCardDescription>
      <TwCardLink
        onClick={() => {
          PageService.goToExtensions()
          Tracking.send(
            TrackingEvent.boardSettingsClickOnOpenExtensionsInBanner
          )
        }}
      >
        {Lang.msg.extensions.boardSettings.promoActionLink}
      </TwCardLink>
    </TwCard>
  )
}

export const ExtensionsGalleryLink = ({
  label,
  onClick
}: {
  label: string
  onClick?: () => void
}) => {
  return (
    <LinkButton
      onClick={() => {
        onClick?.()
        PageService.goToExtensions()
      }}
      size="small"
      className="px-12"
    >
      {label}
    </LinkButton>
  )
}

export const ExtensionsGalleryBanner = () => {
  const [lite, setLite] = React.useState(() => {
    return Storage.getItem(storagePromoVisibilityKey) === 'true'
  })
  const theme = useTheme()

  const onClosePromo = () => {
    setLite(true)
    Storage.setItem(storagePromoVisibilityKey, 'true')
    Tracking.send(TrackingEvent.boardSettingsClickOnCloseInExtensionsBanner)
  }

  return (
    <TwContainer>
      {lite ? (
        <ExtensionsGalleryLink
          label={Lang.msg.extensions.boardSettings.addExtension}
          onClick={() => {
            Tracking.send(TrackingEvent.boardSettingsClickOnAddExtensions)
          }}
        />
      ) : (
        <PromoBlock theme={theme} onClose={onClosePromo} />
      )}
    </TwContainer>
  )
}
